export const BLOG_FREE_DATA = 'BLOG_FREE_DATA'

export const BLOG_CLEAR_RECORDS_LIST = 'BLOG_CLEAR_RECORDS_LIST' // Очистка списка записей
export const BLOG_GET_RECORDS_LIST = 'BLOG_GET_RECORDS_LIST' // Получение списка записей блога
export const BLOG_GET_STATES_LIST = 'BLOG_GET_STATES_LIST' // Получение списка статусов записей блога
export const BLOG_SET_CURRENT_STATUS = 'BLOG_SET_CURRENT_STATUS' // Установка фильтра статуса

export const BLOG_POST_RECORD = 'BLOG_POST_RECORD' // Изменение состояния записи
export const BLOG_ADD_FILE = 'BLOG_ADD_FILE' // Добавление файла к записи
export const BLOG_DEL_FILE = 'BLOG_DEL_FILE' // Удаление файла из записи

export const BLOG_SET_CURRENT_RECORD = 'BLOG_SET_CURRENT_RECORD'
export const BLOG_CREATE_RECORD = 'BLOG_CREATE_RECORD' // Создание новой записи
export const BLOG_UPDATE_RECORD = 'BLOG_UPDATE_RECORD' // Обновление записи
export const BLOG_CANCEL_RECORD = 'BLOG_CANCEL_RECORD' // Уничтожение записи
